<div class="product-add" *ngIf="readProductOption">
  <div fxLayout="flex" fxLayoutAlign="space-between center" class="margin-bottom">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
      <!-- The photo is held locally and uploaded once the product exists,
           the same way staged RFID tags are. -->
      <div class="product-image"
           [class.product-image--empty]="!pendingImagePreview"
           [class.product-image--dragging]="draggingImage"
           (click)="productImageInput.click()"
           (dragover)="onImageDragOver($event)"
           (dragleave)="onImageDragLeave($event)"
           (drop)="onImageDrop($event)"
           [matTooltip]="(pendingImagePreview ? 'product.image.replaceHint' : 'product.image.uploadHint') | translate"
           matTooltipClass="tooltip">

        <img *ngIf="pendingImagePreview" [src]="pendingImagePreview" class="product-image__preview" alt="">

        <div *ngIf="!pendingImagePreview" class="product-image__placeholder">
          <mat-icon>add_a_photo</mat-icon>
        </div>

        <div class="product-image__overlay">
          <mat-icon>photo_camera</mat-icon>
        </div>

        <button type="button" class="product-image__remove"
                *ngIf="pendingImagePreview"
                (click)="$event.stopPropagation(); onRemoveImage()"
                [matTooltip]="'product.image.remove' | translate"
                matTooltipClass="tooltip">
          <mat-icon>close</mat-icon>
        </button>

        <input #productImageInput type="file" accept="image/jpeg,image/png,image/gif,image/webp" hidden (change)="onImageSelected($event)">
      </div>
      <h3>{{ "form.product.addProduct" | translate }}</h3>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px">
      <!-- <button type="button" mat-stroked-button color="primary" class="auto-fill-btn" (click)="onOpenBarcodeLookup()">
        <mat-icon>search</mat-icon>
        <span>{{ "products.lookup.button" | translate }}</span>
      </button> -->
      <div class="asset-toggle-container" *ngIf="locUsesAssetModule === 1" matTooltip="{{ 'form.product.isAssetTooltip' | translate }}" matTooltipClass="tooltip">
        <mat-slide-toggle [formControl]="$any(form.get('prdIsAsset'))" color="primary" class="asset-toggle">
          <span class="asset-toggle-label">{{ 'form.product.asset' | translate }}</span>
        </mat-slide-toggle>
      </div>
      <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!form.valid || (showSerialBlock && serialPatterns$?.length === 0 && form.controls['prdIsSerialized']?.value === true)"
        data-test="product-add__Submit">
        {{ 'form.product.addProduct' | translate }}
      </button>
    </div>
  </div>

    <form [formGroup]="form" class="form">
      <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="cover">
      <div fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" class="margin-right">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "productName" | translate }}</mat-label>
          <input matInput required formControlName="prdNameEn" autocomplete="off">
        </mat-form-field>
        <ng-container *ngIf="form.controls['prdNameEn'].invalid">
          <mat-error *ngIf="form.controls['prdNameEn'].errors.required">
            {{ "form.product.required" | translate }}
          </mat-error>
        </ng-container>
      </div>

      <!-- Asset Number Input - only for assets, before SKU -->
      <div fxFlex="15" fxFlex.sm="100" fxFlex.xs="100" class="margin-right assets-number-field" *ngIf="locUsesAssetModule === 1 && form.get('prdIsAsset')?.value">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ 'form.product.assetNumber' | translate }}</mat-label>
          <input matInput formControlName="prdAssetsNumber" autocomplete="off" maxlength="50" required>
        </mat-form-field>
        <ng-container>
          <mat-error *ngIf="form.controls['prdAssetsNumber'].errors?.required">
            {{ 'form.product.required' | translate }}
          </mat-error>
        </ng-container>
      </div>

      <div fxFlex="20" fxFlex.sm="100" fxFlex.xs="100" class="margin-right">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>SKU</mat-label>
          <input matInput required formControlName="prdCode" (keyup)="onValidatePrdCode($event)"
            autocomplete="off" maxlength="18">
        </mat-form-field>
        <ng-container>
          <mat-error *ngIf="form.controls['prdCode'].errors?.required">
            {{ "form.product.required" | translate }}
          </mat-error>
        </ng-container>
        <ng-container *ngIf="form.controls['prdCode'].errors?.valid == false">
          <mat-error>
            <!-- The SKU belongs to a product that is not at this location:
                 Receiving cannot reach it, so offer to bring it in instead. -->
            <button *ngIf="skuTakenElsewhere" mat-raised-button color="primary" class="receiving-button"
                    (click)="addExistingProductToLocation()">
              {{ skuError | translate }}
              <mat-icon matTooltip="{{ 'tooltip.skuOtherLocation' | translate }}" matTooltipClass="tooltip"
                        class="ToolTip product-edit__tooltip">info</mat-icon>
            </button>
            <button *ngIf="!skuTakenElsewhere" mat-raised-button color="primary" class="receiving-button"
                    (click)="receivingProduct()">
              {{ skuError | translate }}
              <mat-icon matTooltip="{{ 'tooltip.skuReceiving' | translate }}" matTooltipClass="tooltip"
            class="ToolTip product-edit__tooltip">info</mat-icon>
            </button>
          </mat-error>
        </ng-container>
        <ng-container *ngIf="form.controls['prdCode'].errors?.maxLength">
          <mat-error>
            {{ "form.product.maxLength" | translate }}
          </mat-error>
        </ng-container>
      </div>

      <div fxFlex="30" fxFlex.sm="100" fxFlex.xs="100" class="barcode_box">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "products.table.barcodes" | translate }}</mat-label>
            <mat-chip-list #chipList aria-label="Barcode selection" class="product-edit__barcodes" fxLayout="row"
              class="MatChipList" fxLayoutAlign="start start">

              <mat-chip *ngFor="let b of barcodes$; let i = index" selectable="'true'" removable="'true'"
                [ngClass]="b['selected'] == true ? 'MatChip--dark pointer' : 'pointer' "
                (removed)="onBarcodeDelete(i)" (click)="onSelectBarcode(i)"
                [attr.data-chipvalue]="i">
                    {{ b.barcodeData }}
                    <button matChipRemove>
                      <mat-icon>cancel</mat-icon>
                    </button>
              </mat-chip>
              <input placeholder="{{ 'typeNewBarcode' | translate }}" [style.--ph-ch]="('typeNewBarcode' | translate).length" [matChipInputFor]="chipList" matChipInputAddOnBlur="true" id="chipInput" #chipInput
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="onBarcodeSubmit($event)" (keydown)="onBarcodeKeyDown($event)" (keyup)="onBarcodeKeyUp($event)">

            </mat-chip-list>

        </mat-form-field>
        <ng-container *ngIf="isBarcodeValid$ == false && barcodeError">
          <mat-error>
            {{ barcodeError | translate }}
          </mat-error>
        </ng-container>
        <ng-container *ngIf="isBarcodeSingle$ == false && multiBarcodeOption == false">
          <mat-error>
            {{ "barcodeSingleError" | translate }}
          </mat-error>
        </ng-container>
        <!--ng-container>
          <mat-error *ngIf="form.controls['barcodes'].errors?.required">
            {{ "form.product.required" | translate }}
          </mat-error>
        </ng-container-->
      </div>

      <div fxFlex="30" fxFlex.sm="100" fxFlex.xs="100" class="barcode_box" *ngIf="rfidEnabled$ == true">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "rfidTags" | translate }}</mat-label>
            <mat-chip-list #rfidChipList aria-label="RFID tag list" class="product-edit__barcodes MatChipList" fxLayout="row" fxLayoutAlign="start start">
              <mat-chip *ngFor="let v of rfidValues$; let i = index" removable="'true'"
                class="pointer" (removed)="onRfidDelete(i)">
                    {{ v }}
                    <button matChipRemove>
                      <mat-icon>cancel</mat-icon>
                    </button>
              </mat-chip>
              <input placeholder="{{ 'typeNewRfidTag' | translate }}" [matChipInputFor]="rfidChipList" matChipInputAddOnBlur="true"
                (matChipInputTokenEnd)="onRfidSubmit($event)">
            </mat-chip-list>
        </mat-form-field>
      </div>

    </div>


    <!-- Tags: free text on the product, shared by every location. -->
    <div fxLayout="row" class="cover">
      <div fxFlex="100">
        <app-tags-input [tags]="form.value.prdTags" (tagsChange)="form.patchValue({ prdTags: $event }); form.markAsDirty()"></app-tags-input>
      </div>
    </div>

    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="cover">

      <div [fxFlex]="(settings$.locEnableCustomField1 == 1 || settings$.locEnableCustomField2 == 1) ? '48' : '100'" class="description_box" [ngClass]="{'margin-right': settings$.locEnableCustomField1 == 1 || settings$.locEnableCustomField2 == 1}">
        <mat-form-field appearance="outline" class="h-400" floatLabel="always">
          <mat-label>{{ "productDescription" | translate }}</mat-label>
          <textarea matInput formControlName="prdDescription"></textarea>
        </mat-form-field>
      </div>

      <div [fxFlex]="settings$.locEnableCustomField2 == 1 ? '20' : '52'" fxFlex.sm="100" fxFlex.xs="100" [ngClass]="{'margin-right': settings$.locEnableCustomField2 == 1}" *ngIf="settings$.locEnableCustomField1 == 1">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ locPrdCustomFieldLabel1$ }}</mat-label>
          <input matInput formControlName="prdCustomField1" autocomplete="off">
        </mat-form-field>
      </div>

      <div [fxFlex]="settings$.locEnableCustomField1 == 1 ? '30' : '52'" fxFlex.sm="100" fxFlex.xs="100" *ngIf="settings$.locEnableCustomField2 == 1">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ locPrdCustomFieldLabel2$ }}</mat-label>
          <input matInput formControlName="prdCustomField2" autocomplete="off">
        </mat-form-field>
      </div>

    </div>



    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" class="cover">

      <div fxFlex="23" fxFlex.sm="100" fxFlex.xs="100" class="margin-right">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "form.product.category" | translate }}</mat-label>
          <mat-select formControlName="prdCatID">
            <mat-option [value]="data.prdCatID" *ngFor="let data of categories$ | categoryTree">
              <span [innerHTML]="data.prdCatPath || data.prdCatNameEn"></span>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button type="button" mat-button mat-raised-button color="accent" (click)="onAddCategory()"
          class="product-form__categoryBtn" aria-label="Add Button">{{ "addCategory" | translate
          }}</button>
      </div>

      <div fxFlex="24" fxFlex.sm="100" fxFlex.xs="100"  class="margin-right">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>{{ "form.product.brand" | translate }}</mat-label>
          <input matInput formControlName="prdBrand" autocomplete="off">
        </mat-form-field>
      </div>

      <div fxFlex="20" fxFlex.sm="100" fxFlex.xs="100" >
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>UOM</mat-label>
          <input matInput formControlName="prdCasePack" autocomplete="off">
        </mat-form-field>
      </div>



      <!--<div fxFlex="30" fxFlex.sm="100" fxFlex.xs="100"  class="margin-left stored_box">
        <mat-form-field id="chips" appearance="outline" floatLabel="always">
          <mat-label>{{ "form.product.storedAreas" | translate }}</mat-label>

            <mat-chip-list aria-label="selection" formControlName="selectedAreas" #matChipList='matChipList'>
              <div *ngIf="checkedAreas?.length > 0; else emptyBlock">
                <p *ngIf="checkedAreas?.length > 1" class="more__label">
                  <span *ngIf="0 > (checkedAreas.length - 4); else filledBlock">
                  </span>
                  <ng-template #filledBlock>+{{ checkedAreas.length - 3 }} {{ "more" | translate }}</ng-template></p>
                  <div class="mt-12">
                    <mat-chip *ngIf="checkedAreas[0].checked" selectable="true" removable="true"
                      (removed)="onRemoveArea(checkedAreas[0])">
                      <span [innerHTML]="checkedAreas[0].prdAreaNameEn"></span>
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>

                    <mat-chip *ngIf="checkedAreas[1]?.checked" selectable="true" removable="true"
                      (removed)="onRemoveArea(checkedAreas[1])">
                      <span [innerHTML]="checkedAreas[1].prdAreaNameEn"></span>
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>

                    <mat-chip *ngIf="checkedAreas[2]?.checked" selectable="true" removable="true"
                      (removed)="onRemoveArea(checkedAreas[2])">
                      <span [innerHTML]="checkedAreas[2].prdAreaNameEn"></span>
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </div>
              </div>
              <ng-template #emptyBlock>
                <mat-chip class="mt-15">
                  {{ "noStoredAreas" | translate }}
                </mat-chip>
              </ng-template>
            </mat-chip-list>


        </mat-form-field>

        <div>
          <button type="button" class="add_stored" mat-button mat-raised-button color="accent" (click)="onOpenAreas()">{{ "storeInArea" | translate }}</button>
        </div>
      </div>-->

      <div fxFlex="30" fxFlex.sm="100" fxFlex.xs="100" class="margin-left stored_box" *ngIf="readStorageOption">
        <mat-form-field id="chips"  appearance="outline" floatLabel="always">

          <mat-label>{{ "storages" | translate }}</mat-label>

          <mat-chip-list #chipList aria-label="selection" formControlName="selectedStorages">

            <!-- Asset için tek storage göster -->
            <div *ngIf="form.get('prdIsAsset')?.value && checkedStorages?.length > 0">
              <div class="mt-1">
                <mat-chip selectable="true" removable="true" (removed)="onStorageRemove(checkedStorages[0])">
                  <span matTooltip="{{checkedStorages[0].path ? checkedStorages[0].path + ' -> ' : ''}}{{checkedStorages[0].item}}" matTooltipClass="tooltip">{{checkedStorages[0].item}}</span>
                  <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
              </div>
            </div>
            <!-- Normal ürün için çoklu storage -->
            <div *ngIf="!form.get('prdIsAsset')?.value && checkedStorages?.length > 0">
              <div class="mt-1">
                <div *ngFor="let storage of checkedStorages; let i = index">
                  <mat-chip selectable="true" removable="true" (removed)="onStorageRemove(storage)">
                    <span matTooltip="{{storage.path ? storage.path + ' -> ' : ''}}{{storage.item}}" matTooltipClass="tooltip">{{storage.item}}</span>
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </div>
              </div>
            </div>
            <!-- Boş durum -->
            <ng-container *ngIf="checkedStorages?.length === 0">
              <mat-chip class="mt-1">{{ "noStoredStorages" | translate }}</mat-chip>
            </ng-container>
          </mat-chip-list>

        </mat-form-field>
        <div>
          <button type="button" class="add_stored" mat-button mat-raised-button color="accent" (click)="onOpenStorages()">{{ "storeInStorage" | translate }}</button>
        </div>
      </div>



      <div fxFlex="30" fxFlex.sm="100" fxFlex.xs="100" class="serialpattern_edit_box margin-left" *ngIf="showSerialBlock">

        <mat-form-field  appearance="outline" floatLabel="always" [class.mat-form-field-invalid]="serialPatterns$?.length === 0 && form.controls['prdIsSerialized']?.value === true">
          <mat-label>{{ "products.table.serialnumberpatterns" | translate }}</mat-label>
          <mat-chip-list #chipList1 aria-label="SerialPatterns selection" class="product-edit__serialpatterns MatChipList" fxLayout="row" fxLayoutAlign="start start" [disabled]="!form.controls['prdIsSerialized']?.value">
            <mat-chip *ngFor="let b of serialPatterns$; let i = index"
              [ngClass]="b['selected'] == true ? 'MatChip--dark pointer' : 'pointer' " (removed)="onSerialPatternsDelete(i)" (click)="onSelectSerialPatterns(i)"
              [attr.data-chipvalue]="i">
              <span [innerHTML]="b.serialPattern"></span>
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
            <input placeholder="{{ 'typeNewSerialPattern' | translate }}" [matChipInputFor]="chipList1" matChipInputAddOnBlur="true" id="chipInput1" #chipInput1
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="onSerialPatternsSubmit($event)" (keydown)="onSerialPatternsKeyDown($event)" (keyup)="onSerialPatternsKeyUp($event)">
          </mat-chip-list>
        </mat-form-field>
        <ng-container *ngIf="isSerialPatternsValid$ == false && form.controls['prdIsSerialized']?.value === true" class="validation-error">
          <mat-error>
            {{ "serialPatternsDuplicateError" | translate }}
          </mat-error>
        </ng-container>
        <ng-container *ngIf="isBarcodeSingle$==false && multiBarcodeOption==false" class="validation-error">
          <mat-error>
            {{ "serialPatternsSingleError" | translate }}
          </mat-error>
        </ng-container>

        <mat-checkbox formControlName="prdIsSerialized">
          {{'text_is_serialized' | translate}}
        </mat-checkbox>
      </div>


      </div>




      <!-- Count Type Methods Box -->
      <div class="count-methods-box">
        <div class="count-methods-header" fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
            <span class="count-methods-title">{{ "countTypeMethods" | translate }}</span>
            <mat-icon matTooltip="{{ 'tooltip.countMethod' | translate }}" matTooltipClass="tooltip" class="count-methods-info">info</mat-icon>
          </div>
          <button mat-icon-button class="count-methods-add-btn" type="button" (click)="addCount()" *ngIf="countingMethodsAddOption">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <div class="count-methods-content">
          <div formArrayName="counts">
            <div *ngFor="let row of counts.controls; let i = index">
              <div [formGroupName]="i" data-test="product-add__Counts" class="product-add__Counts">
                <div fxLayout="row wrap" fxLayoutGap="12px" fxLayoutGap.lt-md="10px"
                  fxLayoutAlign="start center">
                  <div fxFlex="18" fxFlexAlign="center" class="text-left" fxFlex.lt-md="45">
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>{{ "description" | translate }}</mat-label>
                      <input matInput type="text" placeholder="{{ 'each' | translate }}" required floatLabel="always"
                        formControlName="pcmDesc" autocomplete="off" [readonly]="!countingMethodsDescriptionOption">
                    </mat-form-field>
                  </div>
                  <div fxFlex="10" fxFlexAlign="center" class="text-left" fxFlex.lt-md="45">
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>{{ "quantity" | translate }}</mat-label>
                      <input placeholder="1" required matInput type="text" formControlName="pcmItemQty"
                        autocomplete="off" [readonly]="!countingMethodsQuantityOption || form.get('prdIsAsset')?.value">
                    </mat-form-field>
                  </div>
                  <div fxFlex="10" fxFlexAlign="center" class="text-left count-price-field" fxFlex.lt-md="45" [style.--lbl-ch]="('cost' | translate).length">
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>{{ "cost" | translate }}</mat-label>
                      <input matInput type="text" inputmode="decimal" placeholder="0.00" formControlName="pcmCost" (blur)="roundPrice(row.get('pcmCost'))" autocomplete="off">
<mat-error *ngIf="row.get('pcmCost')?.errors as e">{{ (e.priceMax ? 'products.price.max' : 'products.price.invalid') | translate: { max: priceMaxLabel } }}</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="10" fxFlexAlign="center" class="text-left count-price-field" fxFlex.lt-md="45" [style.--lbl-ch]="('retail' | translate).length">
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>{{ "retail" | translate }}</mat-label>
                      <input matInput type="text" inputmode="decimal" placeholder="0.00" formControlName="pcmRetail" (blur)="roundPrice(row.get('pcmRetail'))" autocomplete="off">
<mat-error *ngIf="row.get('pcmRetail')?.errors as e">{{ (e.priceMax ? 'products.price.max' : 'products.price.invalid') | translate: { max: priceMaxLabel } }}</mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="10" fxFlexAlign="center" class="text-left" fxFlex.lt-md="45" [hidden]="!mls1Option">
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>{{ settings$.locMinQtyLabel1 }}</mat-label>
                      <input matInput type="number" placeholder="0" min="0" formControlName="pcmMinQty1"
                        autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div fxFlex="10" fxFlexAlign="center" class="text-left" fxFlex.lt-md="45"
                    matTooltip="Multiple minimum quantity support is disabled."
                    [matTooltipDisabled]="settings$?.locEnableMultiMinQty == 1" *ngIf="settings$?.locEnableMultiMinQty == 1" [hidden]="!mls2Option">
                    <mat-form-field appearance="outline" floatLabel="always">
                      <mat-label>{{ settings$.locMinQtyLabel2 }}</mat-label>
                      <input matInput type="number" placeholder="0" min="0" formControlName="pcmMinQty2"
                        autocomplete="off" [disabled]="settings$?.locEnableMultiMinQty == 1">
                    </mat-form-field>
                  </div>
                  <div fxFlex="0 0 auto" class="text-center product-form-countBox" *ngIf="countingMethodsCountBy">
                    <mat-radio-group formControlName="pcmIsDefaultCountMethod" required
                      (change)="onToggleDefault(row, i)" class="MatRadioButton--column-reverse">
                      <mat-radio-button [value]="1">
                        {{ "inputs.radio.count-by.text" | translate }}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div fxFlex="0 0 auto" class="text-center product-form-countBox" *ngIf="countingMethodsOrderBy">
                    <mat-radio-group formControlName="pcmIsDefaultOrderMethod" required
                      class="MatRadioButton--column-reverse pl-30" (change)="onToggleOrder(row, i)">
                      <mat-radio-button [value]="1">
                        {{ "inputs.radio.order-by.text" | translate }}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div fxFlex class="product-form-close" *ngIf="countingMethodsAddOption" fxLayoutAlign="end center">
                    <button [disabled]="i == 0" type="button" (click)="onRemoveCount(i, row)" class="count-methods-remove-btn">
                      <mat-icon>close</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </form>

    <div fxLayout="flex" fxLayoutAlign="space-between center" class="bottom_update_btn">
      <h3></h3>
      <div>
        <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="!form.valid || (showSerialBlock && serialPatterns$?.length === 0 && form.controls['prdIsSerialized']?.value === true)"
          data-test="product-add__Submit">
          {{ 'form.product.addProduct' | translate }}
        </button>
      </div>
    </div>

  </div>
